export const formatCurrency = (number: number): string => {
  return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

export const formatCurrencyRound = (number: number): string => {
    return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).replace(/[.]00$/,'');
};

export const formatPercent = (number: number, maximumFractionDigits: number = 0): string => {
  return number.toLocaleString('en-US', { style: 'percent', maximumFractionDigits });
};

export const formatDate = (date: Date | string): string => {
  return new Date(date).toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const formatDateTimeText = (date: Date | string): string => {
  date = new Date(date);
  return (
    date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }) +
    ' ' +
    date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
  );
};

const timeInMsPerUnit = {
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000,
};

export const formatTimeInterval = (dateA, dateB, units: any[] = Object.keys(timeInMsPerUnit)) => {
  const totalDiffMs = Math.abs(dateA - dateB);
  const sortedUnits = units.sort((a, b) => timeInMsPerUnit[b] - timeInMsPerUnit[a]);
  const results = sortedUnits
    .reduce(
      (acc, unit) => {
        if (acc.remainingMs === 0) return acc;

        const timeInMs = timeInMsPerUnit[unit];
        const result = Math.floor(acc.remainingMs / timeInMs);
        const remainingMs = acc.remainingMs % timeInMs;
        const label = unit + (result > 1 ? 's' : '');
        const formattedResult = result && `${result} ${label}`;
        return {
          results: acc.results.concat(formattedResult),
          remainingMs,
        };
      },
      { results: [], remainingMs: totalDiffMs }
    )
    .results.filter((l) => !!l);

  if (results.length > 2) {
    const last = results.pop();
    return `${results.join(', ')}, and ${last}`;
  } else {
    return results.join(' and ');
  }
};
